module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"homeserve-offers","short_name":"homeserve","start_url":"/","background_color":"#663399","display":"minimal-ui","icon":"static/resources/images/favicons/favicon-194x194.png","icons":[{"src":"/resources/images/favicons/android-chrome-192x192.png","sizes":"192x192","type":"image/png"},{"src":"/resources/images/favicons/android-chrome-512x512.png","sizes":"512x512","type":"image/png"}],"legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"403ac7b7fa0e940249e1dd4378829d9e"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
